import { FORM_META_CLEAR_SCHEMA, FORM_META_SET_SCHEMA } from '../types'

const initialState = {}

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case FORM_META_SET_SCHEMA: {
      const { formName, schema } = action.payload
      return {
        ...state,
        [formName]: schema,
      }
    }
    case FORM_META_CLEAR_SCHEMA: {
      const { formName } = action.payload
      // eslint-disable-next-line no-unused-vars
      const { [formName]: _, ...rest } = state
      return rest
    }
    default:
      return state
  }
}

export default reducer
